import createHistory from 'history/createBrowserHistory';

var history = createHistory();

function getQueryVariable(variable) {
    var query = history.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    console.log('Query variable %s not found', variable);
}


export {getQueryVariable}
export default history;



// WEBPACK FOOTER //
// ./src/history.js